import { ApiProperty } from '@nestjs/swagger';
import { IsArray, ArrayNotEmpty, IsUUID } from 'class-validator';

export class AddChaptersBatchDto {
  @ApiProperty({ type: [String], description: 'Liste des chapitres à lier' })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID('4', { each: true })
  chapterIds!: string[];
}

